var render = function render(){var _vm=this,_c=_vm._self._c;return _c('static-string-injector',{attrs:{"string":_vm.slotText,"scope":_vm.scope,"editable":_vm.editable,"preloaded-value":_vm.preloadedValue},scopedSlots:_vm._u([{key:"default",fn:function({ string }){return [_c(_vm.tag,{tag:"component",domProps:{"innerHTML":_vm._s(_vm.nl2br(string))}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }